<template>

    <div id="wrapper">
        <div class="header">
            <a href="appfun:productdetail:pop" class="back iconfont icon-arrow-left "></a>
            <a href="rule.html" class="rules iconfont icon-arrow-right "></a>
        </div>
        <!--轮播-->
        <div class="carousel">
            <div class="swiper-container case">
                <div class="swiper-wrapper bsd load-div">
                    <div class="swiper-slide">
                        <div class="swiper-slideVideo">
                            <video src="https://cloud.video.taobao.com/play/u/1699136323/p/2/e/6/t/1/50119750594.mp4?appKey=38829" id="slideVideo" webkit-playsinline="true" playsinline="true" width="100%" height="100%" type="video/mp4" preload="" x-webkit-airplay="true" x5-playsinline="true" poster="@assets/images/t1.jpg" >
                            </video>
                            <div class="video_btn">
                                <img src="@assets/images/playerBtn.png" />
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide"><img src="@assets/images/t1.jpg" alt="">
                    </div>
                    <div class="swiper-slide"><img src="@assets/images/t2.jpg" alt="">
                    </div>
                    <div class="swiper-slide"><img src="@assets/images/t3.jpg" alt="">
                    </div>
                    <div class="swiper-slide"><img src="@assets/images/t4.jpg" alt="">
                    </div>
                </div>
                <!--视频/图片按钮-->
                <div class="vAndi">
                    <div class="vAndiCont">
                        <div class="videoBtn SWactive">
                            视频
                        </div>
                        <div class="imgBtn">
                            图片
                        </div>
                    </div>
                </div>
                <div class="weizhi">
                    <!--分页-->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@assets/css/swiper.min.css";
    import "@assets/css/style1.css";
    import "@assets/js/jquery.min.js";
    import "@assets/js/swiper.min.js";
    import sendVerifyCode from "@mixins/SendVerifyCode";
    import {createOrder} from "@api/order";
    import { sendcode, checkphone } from "@api/user";
    import {postCartAdd, getLevel, checkuser, belevel} from "@api/store";


    export default {
        name: "Dian",
        mixins: [sendVerifyCode],
        components: {},
        props: {},
        data: function () {
            return {
                wait: 60,
                code: 0,
            };
        },
        mounted: function() {
            (function(doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function() {
                        var clientWidth = docEl.clientWidth;
                        if(!clientWidth) return;
                        docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
                    };
                if(!doc.addEventListener) return;
                win.addEventListener(resizeEvt, recalc, false);
                doc.addEventListener('DOMContentLoaded', recalc, false);
            })(document, window);
            console.log("-------1-------")
            function load(){
                $(".video_btn").hide();
                $("#slideVideo").trigger('play');

            }

            $(".video_btn").on("click", function() {
                $("#slideVideo").trigger('play');
                $(".video_btn").hide();
                return false;
            })
            $(".swiper-slideVideo").on("click", function() {
                $("#slideVideo").trigger('pause');
                $(".video_btn").show();
            })
            $("#slideVideo").on("ended", function() {
                $(".video_btn").show();
            })
            $(".vAndi").show();
            $(".videoBtn").on("click", function() {
                $(".videoBtn").addClass("SWactive");
                $(".imgBtn").removeClass("SWactive");
                swiper1.slideTo(0, 1000, false);
                $(".weizhi").hide();
                return false;
            })
            $(".imgBtn").on("click", function() {
                $(".imgBtn").addClass("SWactive");
                $(".videoBtn").removeClass("SWactive");
                swiper1.slideTo(1, 1000, false);
                $("#slideVideo").trigger('pause');
                $(".video_btn").show();
                $(".weizhi").show();
                return false;
            })
            var swiper1 = new Swiper('.case', {
                pagination: '.swiper-pagination',
                paginationType: 'custom',
                //修改显示数量的下标
                paginationCustomRender: function(swiper, current, total) {
                    var current1 = current - 1;
                    var total1 = total - 1;
                    return current1 + ' / ' + total1;
                },
                paginationClickable: true,
                //							loop: true,

                updateOnImagesReady: true,
                // autoplay : 3000,
                lazyLoading: true,
                lazyLoadingInPrevNext: true,
                lazyLoadingInPrevNextAmount: 2,
                onSlideChangeStart: function(swiper) {
                    var sliderIndex = swiper.activeIndex;
                    $("#slideVideo").trigger('pause');
                    $(".video_btn").show();
                    if(sliderIndex == 0) {
                        $(".videoBtn").addClass("SWactive");
                        $(".imgBtn").removeClass("SWactive");
                        $(".weizhi").hide();
                    } else {
                        $(".imgBtn").addClass("SWactive");
                        $(".videoBtn").removeClass("SWactive");
                        $(".weizhi").show();
                    }
                }
            });
        },
        methods: {
            submit: function (event) {
                let that = this;
                var username = document.getElementById("username").value;
                var phone = document.getElementById("phone").value;
                var code = document.getElementById("code").value;
                var pwd = document.getElementById("pwd").value;
                var repwd = document.getElementById("repwd").value;
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;

                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                console.log(username);

                if (username == "") {
                    alert("请输入姓名");
                    return;
                }
                if (phone == "") {
                    alert("请输入手机号");
                    return;
                }
                if (!(/^1[3456789]\d{9}$/.test(phone))) {
                    alert("手机号码有误，请重填");
                    return false;
                }
                if (code == "") {
                    alert("请输入验证码");
                    return;
                }
                if (code != that.code) {
                    alert("验证码不正确");
                    return;
                }
                if (pwd == "") {
                    alert("请输入密码");
                    return;
                }
                if (repwd == "") {
                    alert("请输入确认密码");
                    return;
                }
                if (repwd != pwd) {
                    alert("两次密码不一样");
                    return;
                }

                let w = {
                    mobile: phone,
                };

                checkphone(w)
                    .then(res => {
                        console.log(res);
                        if (parseInt(res.msg) == 0){
                            alert("手机号已注册");
                            return;
                        }else {
                            checkuser()
                                .then(res => {
                                    console.log(res);
                                    if (parseInt(res.msg) == 0){
                                        alert("你已经注册");
                                        return;
                                    }else {

                                        let q = {
                                            productId: 25,
                                            username: username,
                                            phone: phone,
                                            pwd: pwd,
                                            type:0
                                        };
                                        belevel(q)
                                            .then(function(res) {
                                                alert("信息提交成功")
                                                console.log("------postCartAdd------");
                                                console.log(res.data.cartId);
                                                that.$router.push({ path: "/shenhe"});

                                            })
                                            .catch(res => {
                                                that.isOpen = false;
                                                return that.$dialog.toast({ mes: res.msg });
                                            });

                                    }
                                });
                        }
                    });

            },

            code_num: function() {
                console.log("================");
                var that = this;

                var mobile = document.getElementById("phone").value;
                if (mobile == "") {
                    alert("请输入手机号码");
                    return;
                }

                if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(mobile))) {
                    alert("手机号码有误，请重填");
                    return;
                }


                let w = {
                    mobile: mobile,
                };
                checkphone(w)
                    .then(res => {
                        console.log(res);
                        if (parseInt(res.msg) == -1){

                            this.time_out(this);

                            let u = {
                                mobile: mobile,
                            };
                            sendcode(u)
                                .then(res => {
                                    console.log(res.data.code);
                                    that.code = res.data.code;
                                })
                        }else {
                            alert("手机号已注册");
                            return;
                        }

                    });

            },

            time_out: function(o) {
                console.log("=======time_out=========");
                var that = this;
                var btn = document.getElementById("btn");
                if (that.wait == 0) {
                    btn.removeAttribute("disabled");
                    btn.value = "再次获取";
                    that.wait = 60;
                } else {
                    btn.setAttribute("disabled", true);
                    btn.value = "重获(" + that.wait + ")秒";
                    that.wait--;
                    setTimeout(function () {
                            that.time_out(btn)
                        },
                        1000)
                }
            },

            mounted() {
                console.log("----mounted------");

                var a = document.getElementsByTagName('input');

                for (let i = 0; i < a.length; i++) {
                    a[i].addEventListener('blur', this.fixScroll);
                }
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            },

            destroyed() {
            },

            methods: {
                fixScroll() {
                    window.scrolll(0, 0);
                }
            },


            if (isIos) {
                $('input,textarea').on('blur', function () {
                    window.scroll(0, 0);
                });
                $('select').on('change', function () {
                    window.scroll(0, 0);
                });
            },

            created(){
                console.log("----created------");
                var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                window.onresize = function () {
                    var nowClientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if (clientHeight - nowClientHeight > 60) {//因为ios有自带的底部高度
                        //键盘弹出的事件处理
                        document.getElementById("apply").classList.add("focusState");
                    }
                    else {
                        //键盘收起的事件处理
                        document.getElementById("apply").classList.remove("focusState");
                    }
                };
            },
        }
    };
</script>
